import { logger } from '@/utils/logger.ts';

export const formatDateTime = (dateTimeStr: string): string => {
  return `${formatDate(dateTimeStr)} · ${formatTime(dateTimeStr)}`;
};

export const formatDate = (dateTimeStr: string): string => {
  if (!dateTimeStr) {
    throw new Error('formatDate: dateTimeStr is required');
  }
  const date = new Date(dateTimeStr);
  if (isNaN(date.getTime())) {
    throw new Error(`formatDate: dateTimeStr is invalid "${dateTimeStr}"`);
  }

  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  // 날짜 비교를 위해 시간을 00:00:00으로 설정
  const compareDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  );
  const compareToday = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  );
  const compareYesterday = new Date(
    yesterday.getFullYear(),
    yesterday.getMonth(),
    yesterday.getDate(),
  );

  // 날짜 비교
  if (compareDate.getTime() === compareToday.getTime()) {
    return `오늘`;
  } else if (compareDate.getTime() === compareYesterday.getTime()) {
    return `어제`;
  } else {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const weekDays = ['일', '월', '화', '수', '목', '금', '토'];
    const weekDay = weekDays[date.getDay()];
    return `${month}월 ${day}일 ${weekDay}`;
  }
};

export const formatTime = (dateTimeStr: string): string => {
  if (!dateTimeStr) {
    throw new Error('formatTime: dateTimeStr is required');
  }

  const date = new Date(dateTimeStr);
  if (isNaN(date.getTime())) {
    throw new Error(`formatTime: dateTimeStr is invalid "${dateTimeStr}"`);
  }

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? '오후' : '오전';
  const hour12 = hours % 12 || 12;
  const timeStr = `${ampm} ${hour12}:${minutes.toString().padStart(2, '0')}`;
  return timeStr;
};

/**
 * formate 함수 실행시 에러발생 대신 ' · '를 반환합니다.
 * 커스텀한 에러처리를 원하면 다른 함수를 사용하세요.
 * @param dateTimeStr
 */
export const safeFormatDateTime = (dateTimeStr: string): string => {
  const parts = [
    safeExec(formatDate, dateTimeStr),
    safeExec(formatTime, dateTimeStr),
  ].filter((part) => part !== '');

  return parts.join(' · ');
};

const safeExec = (fn: (s: string) => string, dateTimeStr: string): string => {
  try {
    return fn(dateTimeStr);
  } catch (error) {
    logger.error(error);
    return '';
  }
};

export const isDateInRange = (
  start: string,
  end: string,
  target: Date = new Date(),
): boolean => {
  const startDate = new Date(start);
  const endDate = new Date(end);

  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return false;

  return target >= startDate && target <= endDate;
};

export const formatDateString = (dateStr: string): string => {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${year}년 ${month}월 ${day}일`;
};
